export default __webpack_public_path__ + "static/media/pedagogy-classroom.5703fc89.webp";